



































import { Vue, Component } from 'vue-property-decorator';
import AppBase from '../common/base';

@Component
export default class PartitometroInfo extends AppBase {
    created() {
        this.$store.commit('setTheme', { theme: `results-partitometro info` });
    }

    onCloseClick() {
        this.$router.go(-1);
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/surveys/partitometro-info.vue